import { AsyncValidatorFn, FormBuilder, ValidatorFn, FormControl } from "@angular/forms";

export type WithPropsOfType<T, TP> = {
  [P in keyof T]: TP;
};

export type FormGroupType<TDto> = {
  [K in keyof TDto]: [TDto[K] | {} | undefined, ...(ValidatorFn | ValidatorFn[] | AsyncValidatorFn | AsyncValidatorFn[] | undefined)[]] 
}

export type FormGroupTypeWithFormControls<TDto> = {
  [K in keyof TDto]: FormControl<TDto[K] | null | undefined>
}

export const createTypedFormGroup = <T>(
  formBuilder: FormBuilder,
  formType: FormGroupType<T> | FormGroupTypeWithFormControls<T>
  ) => {
  return formBuilder.group(formType);
} 
